var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"tg-date-picker--control",class:{ active: _vm.isActive },attrs:{"type":"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }